import { createLazyComponent } from '@luna/utils-ui';

export const LazyDevToolsInfoBadge = createLazyComponent(() =>
    import('./DevToolsInfoBadge' /* webpackChunkName: "DevToolsInfoBadge" */).then(
        ({ DevToolsInfoBadge }) => DevToolsInfoBadge,
    ),
);
